import { PageHeader, Subnav } from '@maia/ui';
import { createFileRoute, linkOptions, Outlet } from '@tanstack/react-router';
import { validateSearch } from '../../../../../utils/pagination';
import { getCustomerOptions } from '../../../../../features/customer/shared/customer-query-options';
import { getInsurancesOptions } from '../../../../../features/customer/insurances/queryOptions';

export const Route = createFileRoute(
  '/_authenticated/customers/$guid/edit/_layout',
)({
  component: Layout,
  loaderDeps: ({ search: { page } }) => ({ page }),
  loader: async ({
    context: { queryClient },
    deps: { page },
    params: { guid },
  }) => {
    const customer = await queryClient.ensureQueryData(
      getCustomerOptions(guid, { page }),
    );

    const insurances = await queryClient.ensureQueryData(
      getInsurancesOptions(guid, { page }),
    );
    return { customer, insurances };
  },
  validateSearch: validateSearch,
});

function Layout() {
  const params = Route.useParams();
  const data = Route.useLoaderData();

  return (
    <div className="layout-simple">
      <PageHeader
        backLink={{
          to: '/customers/$guid',
          params: {
            guid: params.guid,
          },
        }}
        title="Wat wil je wijzigen?"
        className="area-page-header"
      />
        <Outlet />
    </div>
  );
}
